import { render } from "./StartFree.vue?vue&type=template&id=bd21b87e&scoped=true"
import script from "./StartFree.vue?vue&type=script&lang=js"
export * from "./StartFree.vue?vue&type=script&lang=js"

import "./StartFree.vue?vue&type=style&index=0&id=bd21b87e&scoped=true&lang=postcss"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd21b87e"]])

export default __exports__